<style lang="scss" scoped>
  .title {
    line-height: 20px;
    padding: 10px 0 5px 0;
  }

  .qp-box {
    &.accessory {
      margin-bottom: 10px;
      padding: 0 10px 10px 0;
    }

    .accessory-list {
      .show-list {
        .list-item {
          position: relative;
          padding: 5px 50px 5px 20px;
          cursor: auto;

          .attachment-delete, .download-link {
            display: inline;
            position: absolute;
            top: 55%;
            transform: translateY(-50%);
            cursor: pointer;
          }

          .download-link {
            right: 15px;
          }

          .attachment-delete {
            right: 40px;
          }

          .download-link {
            color: #9ea7b4;
          }

          &:hover .download-link {
            display: inline;
            color: rgb(92, 214, 255);
          }

          &:hover .attachment-delete {
            display: inline;
            color: red;
          }
        }
      }
    }
  }
</style>
<template>
  <div v-show="fileList.length">
    <div class="qp-box accessory">
      <div class="accessory-list clearfix">
        <div v-if="fileList.length">
          <ul class="show-list">
            <li :key="item.attachmentId" class="list-item" v-for="item in fileList">
              {{ item.attachmentFileName }}

              <el-tag type="warning" v-show="item.attachmentDownloadTime === 0">解析中</el-tag>
              <el-tag type="success" v-show="item.attachmentDownloadTime === 1">正常</el-tag>
              <el-tag type="danger" v-show="item.attachmentDownloadTime === 2">异常</el-tag>
              <span v-show="item.attachmentDownloadTime === 2">
                （{{item.foundationSpaceId}}）
              </span>
              <a @click="deleteItem(item)" class="download-link attachment-delete" v-if="showDelBtn">
                <i class=" el-icon-t-delete"></i>
              </a>
              <a class="download-link" @click.stop="$downloadFile(item)">
                <i class="el-icon-t-download"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {OmsAttachment} from '@/resources';

  export default {
    props: {
      fileList: {
        type: Array,
        default() {
          return [];
        }
      },
      showDelBtn: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      deleteItem(item) {
        OmsAttachment.delete(item.attachmentId).then(res => {
          let index = this.fileList.indexOf(item);
          index !== -1 && this.fileList.splice(index, 1);
        });
      }
    }
  };
</script>
